import React from 'react';
import {FaFileExport, FaGears, FaPrint} from "react-icons/fa6";
import ReportUtils from "../../../utils/report-utils.js";
import Button from "../../button/button.jsx";
import HeaderTemplateButton from "../../button/header-template-button.jsx";
import ScrollTopButton from "../../scroll-top-button/scroll-top-button.jsx";
import {FaEye, FaPen, FaSync} from "react-icons/fa";
import ToggleButton from "../../button/toggle-button.jsx";
import TableColumnVisibility from "../table-column-visibility/table-column-visibility.jsx";

const HeaderButtons = ({exportable = false, exportInSheets = false, printable = false, headerChange = false,
                        editable = false, printComponentRef, reportData, data, headerSelected, setHeaderSelected, setCollapsed, customDelay = null,
                        forceCollapse = false, printImg = null, onPrintImg = null, printOptions = false, setPrintModal,
                        setIsPrinting, reloadable, onReloadReport = null, canPrint = true, viewMode, setViewMode, customPrintTitle = null,
                        visibilityColumns = false, columns, setColumns}) => {

    const hasVisibleColumns = !columns || Object.values(columns).some(column => column.exportOnly !== true && column.exportIgnore !== true && column.visible !== false);

    return (
        <>
            <div className={"flex flex-row gap-2"}>

                { visibilityColumns === true && reportData && data > 0 && (
                    <TableColumnVisibility
                        columns={columns}
                        setColumns={setColumns}
                        onOpenChange={(isOpen) => {
                            if (isOpen) {
                                document.dispatchEvent(new CustomEvent('report-dropdown-open', {
                                    detail: 'columns'
                                }));
                            }
                        }}
                    />
                )}

                { editable === true && reportData && data > 0 && (
                    <ToggleButton
                        viewMode={viewMode}
                        setViewMode={setViewMode}
                        options={[
                            { key: "editor", label: "Modo editor", Icon: FaPen },
                            { key: "viewer", label: "Visualização", Icon: FaEye }
                        ]}
                    />
                )}

                { printOptions === true && reportData && data > 0 && (
                    <Button onClick={() => setPrintModal(true)} title={'Opções de impressão'}>
                        <FaGears size={16}/>
                    </Button>
                )}

                { reloadable === true && (
                    <Button onClick={onReloadReport}>
                        <FaSync/> Recarregar passagens
                    </Button>
                )}

                { exportable === true && reportData && data > 0 && (
                    <Button target='success' title={'Exportar relatório'} disabled={!hasVisibleColumns} onClick={() => ReportUtils.export({ exportInSheets: exportInSheets })}>
                        <FaFileExport/> Exportar
                    </Button>
                )}

                { printable === true && reportData && data > 0 && !printImg && (
                    <Button title={`${customPrintTitle ? customPrintTitle : 'Imprimir relatório'}`} disabled={!canPrint} onClick={() => {
                        const scale = window.visualViewport?.scale ?? 1;
                        if ((window.innerWidth <= 1440 || scale > 1) && setCollapsed) setCollapsed(true);
                        if (forceCollapse) setCollapsed(true);

                        if (setIsPrinting) {
                           setIsPrinting(true);

                           setTimeout(() => {
                               printComponentRef.current?.print();
                           }, 500);

                           setTimeout(() => {
                               setIsPrinting(false);
                           }, 1000);

                           return;
                       }

                      if (customDelay) {
                            setTimeout(() => {
                                printComponentRef.current?.print();
                            }, customDelay);
                      } else {
                          printComponentRef.current?.print();
                      }

                    }}>
                        <FaPrint/>
                    </Button>
                )}

                { printable === true && reportData && data > 0 && printImg && (
                    <Button title={'Imprimir relatório'} onClick={() => {
                        if (forceCollapse) setCollapsed(true);
                        setTimeout(() => {
                            onPrintImg();
                        }, 50);
                    }}>
                        <FaPrint/>
                    </Button>
                )}

                { headerChange === true && reportData && data > 0 && (
                    <HeaderTemplateButton
                        selected={headerSelected}
                        setSelected={setHeaderSelected}
                        onOpenChange={(isOpen) => {
                            if (isOpen) {
                                document.dispatchEvent(new CustomEvent('report-dropdown-open', {
                                    detail: 'header'
                                }));
                            }
                        }}
                    />
                )}
            </div>

            <ScrollTopButton/>
        </>
    );
};

export default HeaderButtons;